module.exports = __webpack_public_path__ + "static/media/cigarettes_01_thumb_hover.485d3da0.png";